import React, { useState } from 'react';
import { RaisedButton } from 'material-ui';
import api from 'services';

function PredictorType(props) {
    const [type, setType] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    /**
     * 
     * @param {MailData} mailData 
     */
    async function getPredictorType(mailData) {
        setIsLoading(true);
        const _type = await api.fetchPredictorType(mailData);
        if (_type.status === 200) {
            setType(_type.data.type);
        } else {
            setType('Error');
        }
        setIsLoading(false);
    }

    return (
        <span style={{ marginLeft: 10 }}>
            <RaisedButton 
                className='btn'
                labelStyle={{ fontSize: '10px', color: 'white' }}
                style={{ height: '25px', margin: '10px 10px 10px 0' }}
                buttonStyle={{ height: '25px', lineHeight: '25px', backgroundColor: '#B26E63' }}
                label='Predictor type'
                onClick={() => getPredictorType(props.mailData)}
                disabled={isLoading}
            />
            <span>{type}</span>
        </span>
    );
}

export default PredictorType;


/**
 * @typedef {Object} MailData
 * @property {string} _id
 * @property {string} text
 * @property {string} owner
 */



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/PredictorType.jsx